// extracted by mini-css-extract-plugin
export default {"desktopWrapper":"PersonalInfo_desktopWrapper__ohJJj","back":"PersonalInfo_back__townn","infoContainer":"PersonalInfo_infoContainer__l3S6L"};